import {
  index as baseIndex,
  request,
 } from './Base';

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all error lines
 */
export function fetchErrorLines(distinct) {
  let search = {}
  if(distinct === true) {
    search.distinct = true;
  }
  return baseIndex('alphalink_api_file_error_lines', 1, 0, search);
}

/******************************************************************************
 * OTHER FUNCTION                                                             *
 ******************************************************************************/

/**
 * start to process error line
 */
export function processErrorLines() {
  return request('/alphalink_file_process_error_lines');
}
